import React, {useState} from 'react';
import {withRouter} from 'react-router';
import {Box, Button, TextField, Typography} from '@mui/material';
import {DateTime} from 'luxon';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import * as elemental_axios_client from 'util/elemental_axios_client';
import useLocalStore from '../../../useLocalStore';
import {useHistory} from 'react-router-dom';
// import {enqueueSnackbar} from 'notistack';

const CreateCampaign = () => {

    const [ , resetSidebar] = useLocalStore(
        (state) => [state.setSidebar, state.resetSidebar]
    );


    const queryClient = useQueryClient();
    const history = useHistory();
    const [ campaignName, setCampaignName ] = useState('');

    const handleCampaignName = (event) => {
        setCampaignName(event.target.value);
    };

    const mutationCreateCampaign = useMutation({
        /** @type {(payload: any) => Promise<any>} */
        mutationFn: (payload) => {
            return elemental_axios_client.post('/campaigns', payload);
        },
        onSuccess: ( campaign) => {

            console.log('campaign created', campaign);
            queryClient.invalidateQueries(['campaigns']);
            resetSidebar();
            if (campaign.message.message_type==='email'){history.push(`/campaigns/${campaign.id}/headers`);}
            if (campaign.message.message_type==='sms'){history.push(`/campaigns/${campaign.id}/message`);}
        }
    });

    const onCreate = async () => {
        const new_campaign = {
            name: campaignName,
            label: `campaign-${DateTime.now().toMillis().toString(36)}`,
            message_type: 'email'
        };

        if(campaignName) {
            mutationCreateCampaign.mutate(new_campaign);
        }
    };

    return (
        <Box className='flow-sidebar' style={{width: 450}}>
            <Box className='flow-sidebar__header'>
                <Typography component='div' variant='subtitle1' className='flow-sidebar_title' style={{borderBottom: 'none'}}>
                    Create a Campaign
                </Typography>
            </Box>
            <Box className='flow-sidebar__body' style={{minWidth: 'max-content'}}>
                <Box className='flow-sidebar__body-content'>
                    <Box display='flex' flexDirection='column'>
                        Campaign Name
                        <TextField size='small' margin='dense' placeholder='New Campaign' onChange={handleCampaignName} value={campaignName} variant='outlined' style={{marginTop: 10, background: '#FFF'}}/>

                        <Box display='flex' alignItems='flex-start'>
                            {/* Message type selection disabled for now; defaulting to email */}

                            <Button onClick={onCreate} className='new_primary_button' style={{margin: 0, marginTop: 10, marginLeft: 'auto', width: 'max-content', height: 'max-content'}} autoFocus>
                                Create
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default withRouter(CreateCampaign);
